import BaseUIStoreSettingPrintingBarcode from 'xui/modules/print/BaseUIStoreSettingPrintingBarcode'

export default class StoreSettingPrintingBarcode extends BaseUIStoreSettingPrintingBarcode {
  static displayName = 'StoreSettingPrintingBarcode'

  static navigationOptions = {
    header: null,
  }
}
